<template>
  <div>
    <q-linear-progress v-if="loading" indeterminate />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { PAGES } from '@/constants'
import { removeDangerSymbols } from '@/services'
import cookiesService from '@/services/cookiesService'
import { useAppStore } from '@/services/store/app'
import { doLoginWithUrl } from '@/views/Login/services'

const loading = ref(false)

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()

const login = async () => {
  loading.value = true

  const cookiesServiceInstance = cookiesService.getService()
  cookiesServiceInstance.clearToken()

  const token = removeDangerSymbols(route?.params?.token)
  if (!token) return

  const res = await doLoginWithUrl(token)
  if (!res) {
    router.push(PAGES.login)
    appStore.logout()
    appStore.setInit()
    return
  }
  router.push(PAGES.main)
  appStore.setInit()
  appStore.setAuth()
}

onMounted(login)
</script>

<style scoped></style>
